/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseDateFieldDefaultValueType } from './DatabaseDateFieldDefaultValueType';
import {
    DatabaseDateFieldDefaultValueTypeFromJSON,
    DatabaseDateFieldDefaultValueTypeFromJSONTyped,
    DatabaseDateFieldDefaultValueTypeToJSON,
} from './DatabaseDateFieldDefaultValueType';
import type { DatabaseDateFieldLook } from './DatabaseDateFieldLook';
import {
    DatabaseDateFieldLookFromJSON,
    DatabaseDateFieldLookFromJSONTyped,
    DatabaseDateFieldLookToJSON,
} from './DatabaseDateFieldLook';
import type { DatabaseDateFieldReminderTemplate } from './DatabaseDateFieldReminderTemplate';
import {
    DatabaseDateFieldReminderTemplateFromJSON,
    DatabaseDateFieldReminderTemplateFromJSONTyped,
    DatabaseDateFieldReminderTemplateToJSON,
} from './DatabaseDateFieldReminderTemplate';
import type { DatabaseDateFieldReminderType } from './DatabaseDateFieldReminderType';
import {
    DatabaseDateFieldReminderTypeFromJSON,
    DatabaseDateFieldReminderTypeFromJSONTyped,
    DatabaseDateFieldReminderTypeToJSON,
} from './DatabaseDateFieldReminderType';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseDateField
 */
export interface DatabaseDateField extends DatabaseField {
    /**
     * 
     * @type {DatabaseDateFieldLook}
     * @memberof DatabaseDateField
     */
    type?: DatabaseDateFieldLook;
    /**
     * 
     * @type {DatabaseDateFieldDefaultValueType}
     * @memberof DatabaseDateField
     */
    defaultValueType?: DatabaseDateFieldDefaultValueType;
    /**
     * 
     * @type {string}
     * @memberof DatabaseDateField
     */
    defaultDateValue?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseDateField
     */
    defaultTimeValue?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseDateField
     */
    defaultValueRange?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseDateField
     */
    reminderActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DatabaseDateField
     */
    reminderRange?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseDateField
     */
    reminderRecipients?: Array<string>;
    /**
     * 
     * @type {DatabaseDateFieldReminderTemplate}
     * @memberof DatabaseDateField
     */
    reminderTemplate?: DatabaseDateFieldReminderTemplate;
    /**
     * Die EIGENE Mail-Vorlage der Datenbank, mit der diese Erinnerung
     * verschickt wird — die `id` aus `emailTemplates`.
     * 
     * WARUM DAS NOETIG IST: Ohne diese Angabe nahm der Versand die
     * ERSTE eigene Vorlage, deren Vorgang zum gewaehlten E-Mail-Typ
     * passt. Wer zwei Erinnerungsvorlagen fuehrt (etwa eine fuer
     * Vertraege und eine fuer Termine), konnte die zweite nie
     * erreichen: Sie stand da, war auswaehlbar — und wurde nie
     * benutzt.
     * 
     * Leer heisst weiterhin „die erste passende, sonst die
     * Standardvorlage". Zeigt die Kennung auf eine geloeschte
     * Vorlage, greift derselbe Rueckfall; eine Erinnerung darf
     * daran nicht scheitern.
     * @type {string}
     * @memberof DatabaseDateField
     */
    reminderTemplateId?: string;
    /**
     * 
     * @type {DatabaseDateFieldReminderType}
     * @memberof DatabaseDateField
     */
    reminderType?: DatabaseDateFieldReminderType;
    /**
     * 
     * @type {string}
     * @memberof DatabaseDateField
     */
    reminderFilter?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseDateField
     */
    withSeconds?: boolean;
}

/**
 * Check if a given object implements the DatabaseDateField interface.
 */
export function instanceOfDatabaseDateField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseDateFieldFromJSON(json: any): DatabaseDateField {
    return DatabaseDateFieldFromJSONTyped(json, false);
}

export function DatabaseDateFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseDateField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'type': !exists(json, 'type') ? undefined : DatabaseDateFieldLookFromJSON(json['type']),
        'defaultValueType': !exists(json, 'defaultValueType') ? undefined : DatabaseDateFieldDefaultValueTypeFromJSON(json['defaultValueType']),
        'defaultDateValue': !exists(json, 'defaultDateValue') ? undefined : json['defaultDateValue'],
        'defaultTimeValue': !exists(json, 'defaultTimeValue') ? undefined : json['defaultTimeValue'],
        'defaultValueRange': !exists(json, 'defaultValueRange') ? undefined : json['defaultValueRange'],
        'reminderActive': !exists(json, 'reminderActive') ? undefined : json['reminderActive'],
        'reminderRange': !exists(json, 'reminderRange') ? undefined : json['reminderRange'],
        'reminderRecipients': !exists(json, 'reminderRecipients') ? undefined : json['reminderRecipients'],
        'reminderTemplate': !exists(json, 'reminderTemplate') ? undefined : DatabaseDateFieldReminderTemplateFromJSON(json['reminderTemplate']),
        'reminderTemplateId': !exists(json, 'reminderTemplateId') ? undefined : json['reminderTemplateId'],
        'reminderType': !exists(json, 'reminderType') ? undefined : DatabaseDateFieldReminderTypeFromJSON(json['reminderType']),
        'reminderFilter': !exists(json, 'reminderFilter') ? undefined : json['reminderFilter'],
        'withSeconds': !exists(json, 'withSeconds') ? undefined : json['withSeconds'],
    };
}

export function DatabaseDateFieldToJSON(value?: DatabaseDateField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'type': DatabaseDateFieldLookToJSON(value.type),
        'defaultValueType': DatabaseDateFieldDefaultValueTypeToJSON(value.defaultValueType),
        'defaultDateValue': value.defaultDateValue,
        'defaultTimeValue': value.defaultTimeValue,
        'defaultValueRange': value.defaultValueRange,
        'reminderActive': value.reminderActive,
        'reminderRange': value.reminderRange,
        'reminderRecipients': value.reminderRecipients,
        'reminderTemplate': DatabaseDateFieldReminderTemplateToJSON(value.reminderTemplate),
        'reminderTemplateId': value.reminderTemplateId,
        'reminderType': DatabaseDateFieldReminderTypeToJSON(value.reminderType),
        'reminderFilter': value.reminderFilter,
        'withSeconds': value.withSeconds,
    };
}

